export enum TipoEstadoActualSecundarioTrackingCorteEnum {
  CONFIRMADO = 'CONFIRMADO',
  BRIGADA_ASIGNADA = 'BRIGADA_ASIGNADA',
  BRIGADA_EN_TERRENO = 'BRIGADA_EN_TERRENO',
  NORMALIZADO = 'NORMALIZADO',
}
